/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.moderation.defs'

type $nsid = typeof $nsid

export { $nsid }

type Attestation = {
  $type?: 'us.edriffles.radlib.moderation.defs#attestation'
  version: 'radlib-list-mute-attestation/1'
  subjectDid: l.DidString

  /**
   * Lower-case SHA-256 hex of the AT-URI of the list.
   */
  listUriHash: string
  providerDid: l.DidString
  issuedAt: l.DatetimeString
  nonce: string
  signature: string
}

export type { Attestation }

const attestation = /*#__PURE__*/ l.typedObject<Attestation>(
  $nsid,
  'attestation',
  /*#__PURE__*/ l.object({
    version: /*#__PURE__*/ l.literal('radlib-list-mute-attestation/1'),
    subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
    listUriHash: /*#__PURE__*/ l.string({ maxLength: 64, minLength: 64 }),
    providerDid: /*#__PURE__*/ l.string({ format: 'did' }),
    issuedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    nonce: /*#__PURE__*/ l.string({ minLength: 16, maxLength: 128 }),
    signature: /*#__PURE__*/ l.string({ minLength: 16, maxLength: 512 }),
  }),
)

export { attestation }
